
export const textInputStyle = {
  labelPosition: "top",
  isRequired: false,
  isUnique: false,
  placeholderText: "",
  width: "100%",
  height: "100%",
  inputType: "text",
  rows: 1,
  fontSize: "16px",
  // padding: "0.5rem",
  // : "0.5rem",
  // : "0.5rem",
  // marginTop: "0.5rem",
  // marginBottom: "0.5rem",
  // borderRadius: "0.25rem",
  // borderStyle: "solid",

  // textColor: "#495057",t
  minLength: undefined,
  maxLength: undefined,
  customRegex: "",
  label: {
    label: "Text Field",
    fontSize: "16px",
    padding: "0.5rem",
    margin: "0.5rem",
    borderColor: "#ced4da",
    backgroundColor: "white",
  },
};

export const numberInputStyle = {
  labelPosition: "top",
  isRequired: false,
  placeholderText: "0",
  inputType:"NUMBER",
  isUnique: true,
  width: "100%",
  height: "100%",
  fontSize: "16px",
  padding: "0.5rem",
  // : "0.5rem",
  // : "0.5rem",
  marginTop: "0.5rem",
  marginBottom: "0.5rem",
  borderRadius: "0.25rem",
  borderStyle: "solid",
  borderColor: "#ced4da",
  backgroundColor: "#FFFFFF",
  textColor: "#495057",
  minValue: undefined,
  maxValue: undefined,
  step: "1",
  label: {
    label: "Number",
    fontSize: "16px",
  },
};


export const multiSelectStyle = {
  labelPosition: "top",
  inputType:"TEXT",
  isRequired: false,
  width: "100%",
  height: "auto",
  maxHeight: "250px", // Controls the height of the checkbox container
  fontSize: "16px",
  padding: "0.5rem",
  marginTop: "0.5rem",
  marginBottom: "0.5rem",
  borderRadius: "0.25rem",
  borderStyle: "solid",
  borderColor: "#ced4da",
  backgroundColor: "#FFFFFF",
  textColor: "#495057",
  options: ["Option 1", "Option 2", "Option 3", "Option 4", "Option 5"],
  optionFontSize: "14px",
  optionTextColor: "#495057",
  checkboxSize: "16px",
  checkboxColor: "#0d6efd",
  showSelectAll: true, // Whether to show the "Select All" option
  showSelectedCount: true, // Whether to show the count of selected items
  label: {
    label: "multiSelect",
    fontSize: "16px",
  },
};

export const fileInputStyle = {
  labelPosition: "top",
  inputType:"FILE",
  isRequired: false,
  width: "100%",
  height: "auto",
  padding: "1rem",
  marginTop: "0.5rem",
  marginBottom: "0.5rem",
  borderRadius: "0.25rem",
  borderStyle: "dashed",
  borderColor: "#ced4da",
  backgroundColor: "#f8f9fa",
  textColor: "#495057",
  buttonColor: "#0d6efd",
  buttonTextColor: "#ffffff",
  dropzoneText: "Drag & drop a file or click to browse",
  acceptedFileTypes: [".jpg", ".jpeg", ".png", ".pdf", ".doc", ".docx"],
  maxFileSize: 10, // In MB
  showPreview: true,
  previewHeight: "200px",
  infoFontSize: "0.85rem",
  label: {
    label: "File Upload",
    fontSize: "16px",
  },
};
export const textareaStyle = {
  labelPosition: "top",
  inputType:"TEXT",
  isRequired: false,
  placeholderText: "Enter text here...",
  width: "100%",
  height: "auto",
  rows: 2,

  fontSize: "16px",
  padding: "0.5rem",
  // : "0.5rem",
  // : "0.5rem",
  marginTop: "0.5rem",
  marginBottom: "0.5rem",
  borderRadius: "0.25rem",
  borderStyle: "solid",
  borderColor: "#ced4da",
  backgroundColor: "#FFFFFF",
  textColor: "#495057",
  minLength: undefined,
  maxLength: undefined,
  label: {
    label: "Text Area",
    fontSize: "16px",
  },
};

export const checkboxStyle = {
  isRequired: false,
  inputType:"BOOLEAN",
  checkboxSize: "16px",
  checkboxColor: "#0d6efd",
  fontSize: "16px",
  textColor: "#495057",
  padding: "0.5rem",
  // : "0.5rem",
  // : "0.5rem",
  marginTop: "0.5rem",
  marginBottom: "0.5rem",
  backgroundColor: "transparent",
  borderRadius: "0.25rem",
  borderStyle: "none",
  borderColor: "#ced4da",
  borderWidth: "0",
  label: {
    label: "Checkbox",
  },
};

export const radioStyle = {
  isRequired: false,
  optionsLayout: "vertical", // Add this new property
  optionsPerRow: 2,
  width: "100%",
  radioSize: "16px",
  inputType: "TEXT",
  radioColor: "#0d6efd",
  fontSize: "16px",

  optionFontSize: "14px",
  optionTextColor: "#495057",
  labelFontWeight: "normal",
  padding: "0.5rem",
  // : "0.5rem",
  // : "0.5rem",
  marginTop: "0.5rem",
  marginBottom: "0.5rem",

  borderRadius: "0.25rem",
  borderStyle: "none",

  borderWidth: "0",
  options: ["Option 1", "Option 2"],
  label: {
    label: "Radio Options",
  },
};

export const selectStyle = {
  labelPosition: "top",
  isRequired: false,
  inputType:"TEXT",
  placeholderText: "Select an option",
  width: "100%",
  height: "auto",
  fontSize: "16px",
  padding: "0.5rem",
  // : "0.5rem",
  // : "0.5rem",
  marginTop: "0.5rem",
  marginBottom: "0.5rem",
  borderRadius: "0.25rem",
  borderStyle: "solid",
  borderColor: "#ced4da",
  backgroundColor: "#FFFFFF",
  textColor: "#495057",
  options: ["Option 1", "Option 2", "Option 3"],
  label: {
    label: "Dropdown",
    fontSize: "16px",
  },
};

export const dividerStyle = {
  thickness: "1px",
  
  color: "#ced4da",
  marginTop: "1rem",
  marginBottom: "1rem",
  width: "100%",
  borderStyle: "solid",
  opacity: "1",
  showLabel: false,
  fontSize: "14px",
  textColor: "#6c757d",
  backgroundColor: "#ffffff",
  labelPadding: "0 0.5rem",
  fontWeight: "normal",
  label: {
    label: "Section Divider",
  },
};

export const textBlockStyle = {
  fontSize: "16px",
  inputType: "TEXT",
  textColor: "#495057",
  backgroundColor: "#f8f9fa",
  backgroundOpacity: "1", // Add background opacity
  width: "100%",
  fontFamily: "inherit",
  padding: "1rem",
  borderRadius: "0.375rem",
  marginTop: "0.5rem",
  marginBottom: "0.5rem",

  borderStyle: "solid",
  borderColor: "#ced4da",
  borderWidth: "1px",
  textAlign: "left",
  fontWeight: "normal",
  fontStyle: "normal",
  lineHeight: "1.5",
  letterSpacing: "normal",
  content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  labelFontSize: "16px",
  labelFontWeight: "bold",
  labelColor: "#212529",
  label: {
    label: "Text Block",
  },
};

export const datePickerStyle = {
  labelPosition: "top",
  inputType:"DATE",
  isRequired: false,
  width: "100%",
  height: "auto",
  fontSize: "16px",
  padding: "0.5rem",
  marginTop: "0.5rem",
  marginBottom: "0.5rem",
  borderRadius: "0.25rem",
  borderStyle: "solid",
  borderColor: "#ced4da",
  backgroundColor: "#FFFFFF",
  textColor: "#495057",
  minDate: undefined,
  maxDate: undefined,
  label: {
    label: "Date",
    fontSize: "16px",
  },
};

export const timePickerStyle = {
  labelPosition: "top",
  inputType:"TIME",
  isRequired: false,
  width: "100%",
  height: "auto",
  fontSize: "16px",
  padding: "0.5rem",
  // : "0.5rem",
  // : "0.5rem",
  marginTop: "0.5rem",
  marginBottom: "0.5rem",
  borderRadius: "0.25rem",
  borderStyle: "solid",
  borderColor: "#ced4da",
  backgroundColor: "#FFFFFF",
  textColor: "#495057",
  minTime: undefined,
  maxTime: undefined,
  step: "60",
  label: {
    label: "Time",
    fontSize: "16px",
  },
};

export const buttonStyle = {
  buttonText: "Submit",
  buttonType: "button",
  actionType: "none",
  showIcon: true,
  icon: "bi-send",
  iconPosition: "left",
  iconSize: "16px",
  disabled: false,
  fontSize: "16px",
  padding: "0.5rem 1rem",
  // : "0.5rem",
  // : "0.5rem",
  marginTop: "0.5rem",
  
  isUnique: true,
  marginBottom: "0.5rem",
  borderRadius: "0.25rem",
  borderStyle: "solid",
  borderColor: "#0d6efd",
  backgroundColor: "#0d6efd",
  textColor: "#ffffff",
  width: "auto", // Changed from 100% to auto
  height: "auto",
  fontWeight: "normal",
  textTransform: "none",
  letterSpacing: "normal",
  alignment: "center", // Add this new property
};

export const imageStyle = {
  imageUrl: "",
  altText: "Image",
  objectFit: "cover",
  alignment: "center",
  width: "100%",
  height: "auto",

  opacity: "1",
  padding: "0",
  // : "0.5rem",
  // : "0.5rem",
  marginTop: "0.5rem",
  marginBottom: "0.5rem",
  borderRadius: "0",
  borderStyle: "none",
  borderColor: "#ced4da",
  borderWidth: "0",
  backgroundColor: "#f8f9fa",
  labelFontSize: "16px",
  labelFontWeight: "bold",
  labelColor: "#212529",
  label: {
    label: "Image",
  },
};

export const sectionStyle = {
  backgroundColor: "#f8f9fa",
  padding: "1rem",
  margin: "1rem 0",
  height: "100%",
  width: "100%",
  borderRadius: "0.25rem",
  borderStyle: "solid",
  borderColor: "#ced4da",
};

export const textTitle = {
  titleText: "Form Title",
  inputType:"TEXT",
  fontSize: "24px",
  fontFamily: "inherit",
  fontWeight: "bold",
  fontStyle: "normal",
  textAlign: "left",
  textTransform: "none",
  letterSpacing: "normal",
  lineHeight: "1.2",
  color: "#212529",
  backgroundColor: "transparent",
  padding: "0.0rem",
  marginTop: "0",
  marginBottom: "0",
  content: "Form Title",
  borderRadius: "0",
  borderStyle: "none",
  borderColor: "#ced4da",
  borderWidth: "0",
  textDecoration: "none",
  textShadow: "none",
  width: "100%",

};
export const defaultComponentStyle = {
  "text-input": textInputStyle,
  "number-input": numberInputStyle,
  textarea: textareaStyle,
  checkbox: checkboxStyle,
  radio: radioStyle,
  select: selectStyle,
  "multiSelect": multiSelectStyle, // Add this
  "file-input": fileInputStyle, // Add this
  divider: dividerStyle,
  text: textBlockStyle,
  date: datePickerStyle,
  time: timePickerStyle,
  button: buttonStyle,
  image: imageStyle,
  section: sectionStyle,
  "text-title": textTitle,
};

export const formStyle = {
  backgroundColor: "#f8f9fa",
  padding: "1rem",
  margin: "1rem 0",
  height: "100%",
  width: "100%",
  borderRadius: "0.25rem",
  borderStyle: "solid",
  borderColor: "#ced4da",
};
